import * as styles from './index.module.scss';

import { graphql, useStaticQuery } from "gatsby";

import Container from '../container';
import { DiscussionEmbed } from 'disqus-react';
import React from 'react';

const Comments = ({ url='undefined', title='undefined' }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  );

  const currentUrl = site.siteMetadata.siteUrl.replace('zuckerjagdwurst', 'zuckerundjagdwurst') + url;

  return (
    <div className={styles.wrapper}>
      <Container>
        <DiscussionEmbed
          shortname='zucker-jagdwurst'
          config={
            {
              url: currentUrl,
              identifier: currentUrl,
              title: title,
              language: 'de_DE' //e.g. for Traditional Chinese (Taiwan)
            }
          }
        />
      </Container>
    </div>
  )
}

export default Comments;
